import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';
import { GroupedPermission, PermissionResponse, RoleResponse } from '@/api/roles/types';

export const createModalConfig = (permissions: GroupedPermission[]) => {
  return [
    {
      label: 'Название',
      key: 'description',
      type: 'text',
      validation: [Validators.required()],
    },
    {
      label: 'Описание',
      key: 'detailedDescription',
      type: 'textarea',
      validation: [Validators.required()],
    },
    {
      label: 'Права доступа',
      key: 'permissions',
      type: 'select',
      payload: {
        options: permissions,
        mode: 'multiple',
        showSearch: true,
        optionFilterProp: 'description',
        fieldNames: {
          label: 'description',
          value: 'name',
          options: 'options',
          groupLabel: 'module',
        },
      },
      validation: [Validators.required()],
    },
  ] as IFormItem[];
};
